import { request } from './http-client'

const widgetService = {
  addTipTopCard: () => request.post('/tiptoppay/add-card', {}),
}

export default widgetService
